import { SET_NEW_THREAD_MODAL_VISIBILITY } from 'redux/actions/types' // eslint-disable-line

const defaultState = {
  newThreadModalVisible: false,
}

const threadsState = (state = defaultState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_NEW_THREAD_MODAL_VISIBILITY:
      return {
        ...state,
        ...{
          newThreadModalVisible: payload,
        },
      }
    default:
      return state
  }
}

export default threadsState
